export type ThemePreference = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'theme';
export const LEGACY_THEME_STORAGE_KEY = 'theme-preference';
export const THEME_PREF_COOKIE_KEY = 'ta_theme_pref';
export const THEME_RESOLVED_COOKIE_KEY = 'ta_theme_resolved';

export const parseThemePreference = (value: string | null): ThemePreference => {
  if (value === 'light' || value === 'dark' || value === 'system') {
    return value;
  }
  return 'system';
};

export const resolveTheme = (preference: ThemePreference, prefersDark: boolean): ResolvedTheme => {
  if (preference === 'system') {
    return prefersDark ? 'dark' : 'light';
  }
  return preference;
};

export const applyTheme = (value: ResolvedTheme) => {
  if (!process.client) {
    return;
  }
  const root = document.documentElement;
  root.setAttribute('data-theme', value);
  root.style.colorScheme = value;
};
